import SEOHead from '@/components/base/SEOHead';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function PrivacyPolicy() {
  return (
    <>
      <SEOHead
        title="Privacy Policy – All Yono Games"
        description="Read the privacy policy for All Yono Games. Learn how we collect, use, and protect your information when you visit our game directory website."
        keywords="Privacy Policy, Yono Games Privacy, Data Protection"
      />

      <Header />

      <main>
        <div className="px-4 py-6">
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-4">
            Privacy Policy
          </h1>
          <p className="text-foreground-400 text-[11px] mb-5">Last updated: July 13, 2026</p>

          <div className="space-y-4 text-foreground-600 text-[13px] leading-relaxed">
            <p>
              At All Yono Games, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by All Yono Games and how we use it.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Information We Collect</h2>
            <p>
              We do not collect personal information directly through our website. Our website is an informational directory that does not require user registration, login, or account creation. We do not store or process any personal data from our visitors.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Log Files</h2>
            <p>
              All Yono Games follows a standard procedure of using log files. These files log visitors when they visit websites. The information collected by log files includes internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Cookies</h2>
            <p>
              Our website may use cookies to enhance user experience. You can choose to disable cookies through your individual browser options. More detailed information about cookie management with specific web browsers can be found at the browsers' respective websites.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Third-Party Links</h2>
            <p>
              Our website contains links to external websites and third-party applications. Please note that we are not responsible for the privacy practices or content of these external sites. We encourage users to review the privacy policies of any third-party services they access through our links.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Children's Information</h2>
            <p>
              Our website is not intended for use by children under the age of 18. We do not knowingly collect personal information from children. If you believe your child has provided personal information on our website, please contact us immediately and we will make our best efforts to remove such information.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Changes to This Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}